export enum BuildingEndpoints {
    getBuildings = '/v1/buildings',
    getOffers = '/v1/bookings/{id}/offers',
}
